import { createContext } from 'react'

export const AgentDataContext = createContext(null)

